import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ChevronLeftIcon, CalendarIcon, UserIcon, PhoneIcon, MailIcon, MapPinIcon, DollarSignIcon, UsersIcon, ClockIcon, CheckCircleIcon, XCircleIcon, AlertCircleIcon, EditIcon, PrinterIcon, DownloadIcon, FileTextIcon, CreditCardIcon, SendIcon, MessageSquareIcon, PlusIcon, ExternalLinkIcon } from 'lucide-react';
// Mock bookings data (same as in BookingsModule)
const bookingsData = [{
  id: 1,
  reference: 'BK-78945',
  customer: {
    name: 'Emily Wilson',
    email: 'ewilson@example.com',
    phone: '+1 (555) 789-0123'
  },
  package: 'Luxury Bali Retreat',
  destination: 'Bali, Indonesia',
  travelDates: 'Jul 20 - Jul 27, 2023',
  bookingDate: '2023-06-02T15:45:00',
  totalAmount: 3950,
  paidAmount: 1975,
  balance: 1975,
  status: 'confirmed',
  paymentStatus: 'deposit-paid',
  travelers: '2 adults',
  agent: 'David Miller',
  details: {
    accommodation: 'Luxury Villas Bali - Private Pool Villa',
    checkIn: '2023-07-20',
    checkOut: '2023-07-27',
    roomType: 'One Bedroom Villa with Private Pool',
    mealPlan: 'Breakfast included',
    inclusions: ['Round-trip airport transfers', 'Daily breakfast', 'Welcome drink on arrival', 'Complimentary WiFi', 'One romantic dinner for two', 'Couples spa treatment (60 minutes)', 'Half-day guided tour'],
    specialRequests: 'Honeymoon decoration in room, late check-out if possible',
    cancellationPolicy: 'Free cancellation up to 30 days before arrival. 50% charge for cancellations within 30-14 days. No refund for cancellations within 14 days of arrival.'
  },
  payments: [{
    id: 1,
    date: '2023-06-02T15:45:00',
    amount: 1975,
    method: 'Credit Card',
    reference: 'PAY-12345',
    type: 'Deposit',
    status: 'completed'
  }],
  documents: [{
    id: 1,
    name: 'Booking Confirmation',
    date: '2023-06-02T16:00:00',
    type: 'pdf'
  }, {
    id: 2,
    name: 'Invoice #INV-5678',
    date: '2023-06-02T16:05:00',
    type: 'pdf'
  }, {
    id: 3,
    name: 'Travel Itinerary',
    date: '2023-06-03T10:30:00',
    type: 'pdf'
  }],
  activities: [{
    id: 1,
    type: 'booking_created',
    date: '2023-06-02T15:45:00',
    user: 'David Miller',
    content: 'Booking created and confirmation sent to customer'
  }, {
    id: 2,
    type: 'payment',
    date: '2023-06-02T15:45:00',
    user: 'David Miller',
    content: 'Deposit payment of $1,975.00 received via Credit Card'
  }, {
    id: 3,
    type: 'email',
    date: '2023-06-03T10:30:00',
    user: 'David Miller',
    content: 'Sent detailed itinerary and pre-departure information'
  }, {
    id: 4,
    type: 'note',
    date: '2023-06-05T14:15:00',
    user: 'David Miller',
    content: 'Customer called to confirm receipt of documents and asked about transportation options from airport to hotel'
  }]
}, {
  id: 2,
  reference: 'BK-78946',
  customer: {
    name: 'Robert Chen',
    email: 'robert.chen@example.com',
    phone: '+1 (555) 123-4567'
  },
  package: 'Japan Family Explorer',
  destination: 'Japan',
  travelDates: 'Oct 15 - Oct 28, 2023',
  bookingDate: '2023-06-12T10:30:00',
  totalAmount: 6850,
  paidAmount: 2000,
  balance: 4850,
  status: 'confirmed',
  paymentStatus: 'deposit-paid',
  travelers: '2 adults, 1 child',
  agent: 'Sarah Johnson',
  details: {
    accommodation: 'Multiple hotels - Tokyo, Kyoto, Osaka',
    checkIn: '2023-10-15',
    checkOut: '2023-10-28',
    roomType: 'Family Rooms/Connecting Rooms',
    mealPlan: 'Breakfast included',
    inclusions: ['Airport transfers in Tokyo and Osaka', 'Japan Rail Pass (7 days)', 'Tokyo city tour', 'Kyoto cultural experience', 'Mt. Fuji day trip', 'Osaka food tour', 'Family-friendly activities in each city'],
    specialRequests: 'Child is 8 years old. Need rooms close to elevator. Vegetarian meal options.',
    cancellationPolicy: 'Free cancellation up to 60 days before arrival. 30% charge for cancellations within 60-30 days. 50% charge within 30-14 days. No refund for cancellations within 14 days of arrival.'
  },
  payments: [{
    id: 1,
    date: '2023-06-12T10:30:00',
    amount: 2000,
    method: 'Bank Transfer',
    reference: 'PAY-23456',
    type: 'Deposit',
    status: 'completed'
  }],
  documents: [{
    id: 1,
    name: 'Booking Confirmation',
    date: '2023-06-12T11:00:00',
    type: 'pdf'
  }, {
    id: 2,
    name: 'Invoice #INV-6789',
    date: '2023-06-12T11:05:00',
    type: 'pdf'
  }, {
    id: 3,
    name: 'Preliminary Itinerary',
    date: '2023-06-13T09:30:00',
    type: 'pdf'
  }],
  activities: [{
    id: 1,
    type: 'booking_created',
    date: '2023-06-12T10:30:00',
    user: 'Sarah Johnson',
    content: 'Booking created and confirmation sent to customer'
  }, {
    id: 2,
    type: 'payment',
    date: '2023-06-12T10:30:00',
    user: 'Sarah Johnson',
    content: 'Deposit payment of $2,000.00 received via Bank Transfer'
  }, {
    id: 3,
    type: 'note',
    date: '2023-06-13T09:30:00',
    user: 'Sarah Johnson',
    content: 'Sent preliminary itinerary for review. Will finalize after customer feedback.'
  }, {
    id: 4,
    type: 'email',
    date: '2023-06-15T16:45:00',
    user: 'Sarah Johnson',
    content: 'Received customer feedback on itinerary. They requested more time in Kyoto and less in Osaka.'
  }]
}
// Other bookings would be defined here
];
export const BookingDetails = () => {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newNote, setNewNote] = useState('');
  const [activeTab, setActiveTab] = useState('details');
  useEffect(() => {
    // Simulate API fetch
    setLoading(true);
    setTimeout(() => {
      const foundBooking = bookingsData.find(b => b.id === parseInt(id));
      setBooking(foundBooking);
      setLoading(false);
    }, 300);
  }, [id]);
  if (loading) {
    return <div className="flex items-center justify-center h-64" data-id="element-423">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500" data-id="element-424"></div>
      </div>;
  }
  if (!booking) {
    return <div className="flex flex-col items-center justify-center h-64" data-id="element-425">
        <CalendarIcon className="h-12 w-12 text-gray-300 mb-4" data-id="element-426" />
        <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-427">
          Booking not found
        </h3>
        <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" onClick={() => navigate('/bookings')} data-id="element-428">
          Back to Bookings
        </button>
      </div>;
  }
  const getStatusBadge = status => {
    switch (status) {
      case 'confirmed':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-429">
            <CheckCircleIcon className="h-3 w-3 mr-1" data-id="element-430" />
            Confirmed
          </span>;
      case 'pending-confirmation':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-431">
            <ClockIcon className="h-3 w-3 mr-1" data-id="element-432" />
            Pending
          </span>;
      case 'cancelled':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-433">
            <XCircleIcon className="h-3 w-3 mr-1" data-id="element-434" />
            Cancelled
          </span>;
      default:
        return null;
    }
  };
  const getPaymentStatusBadge = status => {
    switch (status) {
      case 'paid':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-435">
            Paid
          </span>;
      case 'deposit-paid':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-436">
            Deposit Paid
          </span>;
      case 'unpaid':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-437">
            Unpaid
          </span>;
      case 'refunded':
        return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-438">
            Refunded
          </span>;
      default:
        return null;
    }
  };
  const formatDate = dateString => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  const formatSimpleDate = dateString => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };
  const getActivityIcon = type => {
    switch (type) {
      case 'booking_created':
        return <CalendarIcon className="h-5 w-5 text-green-500" data-id="element-439" />;
      case 'payment':
        return <DollarSignIcon className="h-5 w-5 text-blue-500" data-id="element-440" />;
      case 'email':
        return <MailIcon className="h-5 w-5 text-purple-500" data-id="element-441" />;
      case 'note':
        return <MessageSquareIcon className="h-5 w-5 text-gray-500" data-id="element-442" />;
      default:
        return <ClockIcon className="h-5 w-5 text-gray-500" data-id="element-443" />;
    }
  };
  const handleAddNote = () => {
    if (!newNote.trim()) return;
    // In a real app, this would be an API call
    console.log('Adding note:', newNote);
    setNewNote('');
    // Simulate adding a note to the activity timeline
    const updatedBooking = {
      ...booking,
      activities: [{
        id: Math.max(...booking.activities.map(a => a.id)) + 1,
        type: 'note',
        content: newNote,
        date: new Date().toISOString(),
        user: booking.agent
      }, ...booking.activities]
    };
    setBooking(updatedBooking);
  };
  const handleRecordPayment = () => {
    // In a real app, this would open a payment form
    console.log('Record payment for booking:', booking.reference);
  };
  return <div className="space-y-6" data-id="element-444">
      <div className="flex items-center" data-id="element-445">
        <button className="mr-4 text-gray-500 hover:text-gray-700" onClick={() => navigate('/bookings')} data-id="element-446">
          <ChevronLeftIcon className="h-6 w-6" data-id="element-447" />
        </button>
        <div data-id="element-448">
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-449">Booking Details</h1>
          <p className="text-sm text-gray-500" data-id="element-450">
            {booking.reference} - {booking.customer.name}
          </p>
        </div>
      </div>
      {/* Booking header card */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-451">
        <div className="p-6" data-id="element-452">
          <div className="flex justify-between items-start mb-4" data-id="element-453">
            <div data-id="element-454">
              <h2 className="text-xl font-medium text-gray-800" data-id="element-455">
                {booking.package}
              </h2>
              <div className="flex items-center mt-1" data-id="element-456">
                <MapPinIcon className="h-4 w-4 text-gray-400 mr-1" data-id="element-457" />
                <span className="text-gray-600" data-id="element-458">{booking.destination}</span>
              </div>
            </div>
            <div className="flex space-x-2" data-id="element-459">
              {getStatusBadge(booking.status)}
              {getPaymentStatusBadge(booking.paymentStatus)}
            </div>
          </div>
          <div className="grid grid-cols-4 gap-4 mt-6" data-id="element-460">
            <div className="flex items-start" data-id="element-461">
              <CalendarIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-2" data-id="element-462" />
              <div data-id="element-463">
                <p className="text-sm font-medium text-gray-500" data-id="element-464">
                  Travel Dates
                </p>
                <p className="text-gray-800" data-id="element-465">{booking.travelDates}</p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-466">
              <UsersIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-2" data-id="element-467" />
              <div data-id="element-468">
                <p className="text-sm font-medium text-gray-500" data-id="element-469">Travelers</p>
                <p className="text-gray-800" data-id="element-470">{booking.travelers}</p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-471">
              <DollarSignIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-2" data-id="element-472" />
              <div data-id="element-473">
                <p className="text-sm font-medium text-gray-500" data-id="element-474">
                  Total Amount
                </p>
                <p className="text-gray-800" data-id="element-475">${booking.totalAmount}</p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-476">
              <UserIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-2" data-id="element-477" />
              <div data-id="element-478">
                <p className="text-sm font-medium text-gray-500" data-id="element-479">
                  Booking Agent
                </p>
                <p className="text-gray-800" data-id="element-480">{booking.agent}</p>
              </div>
            </div>
          </div>
          <div className="flex justify-between items-center mt-6 pt-6 border-t border-gray-200" data-id="element-481">
            <div className="flex space-x-2" data-id="element-482">
              <button className="px-3 py-1.5 bg-white border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 flex items-center" data-id="element-483">
                <PrinterIcon className="h-4 w-4 mr-2" data-id="element-484" />
                Print
              </button>
              <button className="px-3 py-1.5 bg-white border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 flex items-center" data-id="element-485">
                <DownloadIcon className="h-4 w-4 mr-2" data-id="element-486" />
                Download
              </button>
              <button className="px-3 py-1.5 bg-white border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 flex items-center" data-id="element-487">
                <MailIcon className="h-4 w-4 mr-2" data-id="element-488" />
                Email
              </button>
            </div>
            <div className="flex space-x-2" data-id="element-489">
              <button className="px-3 py-1.5 bg-white border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 flex items-center" data-id="element-490">
                <EditIcon className="h-4 w-4 mr-2" data-id="element-491" />
                Edit
              </button>
              {booking.balance > 0 && <button className="px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center" onClick={handleRecordPayment} data-id="element-492">
                  <CreditCardIcon className="h-4 w-4 mr-2" data-id="element-493" />
                  Record Payment
                </button>}
            </div>
          </div>
        </div>
      </div>
      {/* Tabs */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-494">
        <div className="border-b border-gray-200" data-id="element-495">
          <nav className="flex" data-id="element-496">
            <button className={`px-6 py-3 text-sm font-medium ${activeTab === 'details' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('details')} data-id="element-497">
              Details
            </button>
            <button className={`px-6 py-3 text-sm font-medium ${activeTab === 'payments' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('payments')} data-id="element-498">
              Payments
            </button>
            <button className={`px-6 py-3 text-sm font-medium ${activeTab === 'documents' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('documents')} data-id="element-499">
              Documents
            </button>
            <button className={`px-6 py-3 text-sm font-medium ${activeTab === 'activity' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} onClick={() => setActiveTab('activity')} data-id="element-500">
              Activity
            </button>
          </nav>
        </div>
        <div className="p-6" data-id="element-501">
          {/* Details Tab */}
          {activeTab === 'details' && <div className="grid grid-cols-3 gap-6" data-id="element-502">
              {/* Left Column - Booking Details */}
              <div className="col-span-2 space-y-6" data-id="element-503">
                <div data-id="element-504">
                  <h3 className="text-lg font-medium text-gray-800 mb-3" data-id="element-505">
                    Booking Details
                  </h3>
                  <div className="bg-gray-50 rounded-lg p-4" data-id="element-506">
                    <div className="grid grid-cols-2 gap-4" data-id="element-507">
                      <div data-id="element-508">
                        <p className="text-sm font-medium text-gray-500" data-id="element-509">
                          Accommodation
                        </p>
                        <p className="text-gray-800" data-id="element-510">
                          {booking.details.accommodation}
                        </p>
                      </div>
                      <div data-id="element-511">
                        <p className="text-sm font-medium text-gray-500" data-id="element-512">
                          Room Type
                        </p>
                        <p className="text-gray-800" data-id="element-513">
                          {booking.details.roomType}
                        </p>
                      </div>
                      <div data-id="element-514">
                        <p className="text-sm font-medium text-gray-500" data-id="element-515">
                          Check-in
                        </p>
                        <p className="text-gray-800" data-id="element-516">
                          {formatSimpleDate(booking.details.checkIn)}
                        </p>
                      </div>
                      <div data-id="element-517">
                        <p className="text-sm font-medium text-gray-500" data-id="element-518">
                          Check-out
                        </p>
                        <p className="text-gray-800" data-id="element-519">
                          {formatSimpleDate(booking.details.checkOut)}
                        </p>
                      </div>
                      <div data-id="element-520">
                        <p className="text-sm font-medium text-gray-500" data-id="element-521">
                          Meal Plan
                        </p>
                        <p className="text-gray-800" data-id="element-522">
                          {booking.details.mealPlan}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-id="element-523">
                  <h3 className="text-lg font-medium text-gray-800 mb-3" data-id="element-524">
                    Inclusions
                  </h3>
                  <ul className="bg-gray-50 rounded-lg p-4 space-y-2" data-id="element-525">
                    {booking.details.inclusions.map((inclusion, index) => <li key={index} className="flex items-start" data-id="element-526">
                        <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-527" />
                        <span className="text-gray-700" data-id="element-528">{inclusion}</span>
                      </li>)}
                  </ul>
                </div>
                {booking.details.specialRequests && <div data-id="element-529">
                    <h3 className="text-lg font-medium text-gray-800 mb-3" data-id="element-530">
                      Special Requests
                    </h3>
                    <div className="bg-gray-50 rounded-lg p-4" data-id="element-531">
                      <p className="text-gray-700" data-id="element-532">
                        {booking.details.specialRequests}
                      </p>
                    </div>
                  </div>}
                <div data-id="element-533">
                  <h3 className="text-lg font-medium text-gray-800 mb-3" data-id="element-534">
                    Cancellation Policy
                  </h3>
                  <div className="bg-gray-50 rounded-lg p-4" data-id="element-535">
                    <p className="text-gray-700" data-id="element-536">
                      {booking.details.cancellationPolicy}
                    </p>
                  </div>
                </div>
              </div>
              {/* Right Column - Customer Info */}
              <div data-id="element-537">
                <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden mb-6" data-id="element-538">
                  <div className="p-4 border-b border-gray-200" data-id="element-539">
                    <h3 className="text-lg font-medium text-gray-800" data-id="element-540">
                      Customer Information
                    </h3>
                  </div>
                  <div className="p-4" data-id="element-541">
                    <div className="flex items-center mb-4" data-id="element-542">
                      <div className="h-12 w-12 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 mr-3" data-id="element-543">
                        <UserIcon className="h-6 w-6" data-id="element-544" />
                      </div>
                      <div data-id="element-545">
                        <p className="font-medium text-gray-800" data-id="element-546">
                          {booking.customer.name}
                        </p>
                        <p className="text-sm text-gray-500" data-id="element-547">Customer</p>
                      </div>
                    </div>
                    <div className="space-y-3" data-id="element-548">
                      <div className="flex items-center" data-id="element-549">
                        <MailIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-550" />
                        <a href={`mailto:${booking.customer.email}`} className="text-blue-600 hover:text-blue-800" data-id="element-551">
                          {booking.customer.email}
                        </a>
                      </div>
                      <div className="flex items-center" data-id="element-552">
                        <PhoneIcon className="h-5 w-5 text-gray-400 mr-2" data-id="element-553" />
                        <a href={`tel:${booking.customer.phone}`} className="text-blue-600 hover:text-blue-800" data-id="element-554">
                          {booking.customer.phone}
                        </a>
                      </div>
                    </div>
                    <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-555">
                      <button className="w-full px-4 py-2 bg-white border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 flex items-center justify-center" data-id="element-556">
                        <UserIcon className="h-4 w-4 mr-2" data-id="element-557" />
                        View Customer Profile
                      </button>
                    </div>
                  </div>
                </div>
                <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden" data-id="element-558">
                  <div className="p-4 border-b border-gray-200" data-id="element-559">
                    <h3 className="text-lg font-medium text-gray-800" data-id="element-560">
                      Payment Summary
                    </h3>
                  </div>
                  <div className="p-4" data-id="element-561">
                    <div className="space-y-2" data-id="element-562">
                      <div className="flex justify-between" data-id="element-563">
                        <span className="text-gray-600" data-id="element-564">Total Amount</span>
                        <span className="font-medium" data-id="element-565">
                          ${booking.totalAmount}
                        </span>
                      </div>
                      <div className="flex justify-between" data-id="element-566">
                        <span className="text-gray-600" data-id="element-567">Paid Amount</span>
                        <span className="font-medium text-green-600" data-id="element-568">
                          ${booking.paidAmount}
                        </span>
                      </div>
                      {booking.balance > 0 && <div className="flex justify-between" data-id="element-569">
                          <span className="text-gray-600" data-id="element-570">Balance Due</span>
                          <span className="font-medium text-red-600" data-id="element-571">
                            ${booking.balance}
                          </span>
                        </div>}
                    </div>
                    {booking.balance > 0 && <button className="w-full mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center justify-center" onClick={handleRecordPayment} data-id="element-572">
                        <CreditCardIcon className="h-4 w-4 mr-2" data-id="element-573" />
                        Record Payment
                      </button>}
                  </div>
                </div>
              </div>
            </div>}
          {/* Payments Tab */}
          {activeTab === 'payments' && <div data-id="element-574">
              <div className="flex justify-between items-center mb-6" data-id="element-575">
                <h3 className="text-lg font-medium text-gray-800" data-id="element-576">
                  Payment History
                </h3>
                {booking.balance > 0 && <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center" onClick={handleRecordPayment} data-id="element-577">
                    <CreditCardIcon className="h-4 w-4 mr-2" data-id="element-578" />
                    Record Payment
                  </button>}
              </div>
              <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden mb-6" data-id="element-579">
                <div className="p-4 border-b border-gray-200 bg-gray-50" data-id="element-580">
                  <div className="grid grid-cols-5 gap-4" data-id="element-581">
                    <div className="text-sm font-medium text-gray-500" data-id="element-582">
                      Date
                    </div>
                    <div className="text-sm font-medium text-gray-500" data-id="element-583">
                      Amount
                    </div>
                    <div className="text-sm font-medium text-gray-500" data-id="element-584">
                      Method
                    </div>
                    <div className="text-sm font-medium text-gray-500" data-id="element-585">
                      Type
                    </div>
                    <div className="text-sm font-medium text-gray-500" data-id="element-586">
                      Status
                    </div>
                  </div>
                </div>
                <div data-id="element-587">
                  {booking.payments.map(payment => <div key={payment.id} className="p-4 border-b border-gray-200 last:border-0" data-id="element-588">
                      <div className="grid grid-cols-5 gap-4" data-id="element-589">
                        <div className="text-sm text-gray-900" data-id="element-590">
                          {formatSimpleDate(payment.date)}
                        </div>
                        <div className="text-sm font-medium text-gray-900" data-id="element-591">
                          ${payment.amount}
                        </div>
                        <div className="text-sm text-gray-900" data-id="element-592">
                          {payment.method}
                        </div>
                        <div className="text-sm text-gray-900" data-id="element-593">
                          {payment.type}
                        </div>
                        <div className="text-sm" data-id="element-594">
                          {payment.status === 'completed' ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-595">
                              Completed
                            </span> : <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800" data-id="element-596">
                              Pending
                            </span>}
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden" data-id="element-597">
                <div className="p-4 border-b border-gray-200" data-id="element-598">
                  <h3 className="text-lg font-medium text-gray-800" data-id="element-599">
                    Payment Summary
                  </h3>
                </div>
                <div className="p-4" data-id="element-600">
                  <div className="space-y-3" data-id="element-601">
                    <div className="flex justify-between" data-id="element-602">
                      <span className="text-gray-600" data-id="element-603">
                        Total Booking Amount
                      </span>
                      <span className="font-medium" data-id="element-604">
                        ${booking.totalAmount}
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-605">
                      <span className="text-gray-600" data-id="element-606">Total Paid</span>
                      <span className="font-medium text-green-600" data-id="element-607">
                        ${booking.paidAmount}
                      </span>
                    </div>
                    {booking.balance > 0 ? <div className="flex justify-between" data-id="element-608">
                        <span className="text-gray-600" data-id="element-609">Balance Due</span>
                        <span className="font-medium text-red-600" data-id="element-610">
                          ${booking.balance}
                        </span>
                      </div> : <div className="flex justify-between" data-id="element-611">
                        <span className="text-gray-600" data-id="element-612">Balance</span>
                        <span className="font-medium text-green-600" data-id="element-613">
                          $0 (Paid in Full)
                        </span>
                      </div>}
                  </div>
                  {booking.balance > 0 && <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-614">
                      <p className="text-sm text-gray-600 mb-2" data-id="element-615">
                        Payment due by:{' '}
                        <span className="font-medium" data-id="element-616">
                          {formatSimpleDate(booking.details.checkIn)}
                        </span>
                      </p>
                      <button className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center justify-center" onClick={handleRecordPayment} data-id="element-617">
                        <CreditCardIcon className="h-4 w-4 mr-2" data-id="element-618" />
                        Record Payment
                      </button>
                    </div>}
                </div>
              </div>
            </div>}
          {/* Documents Tab */}
          {activeTab === 'documents' && <div data-id="element-619">
              <div className="flex justify-between items-center mb-6" data-id="element-620">
                <h3 className="text-lg font-medium text-gray-800" data-id="element-621">Documents</h3>
                <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center" data-id="element-622">
                  <PlusIcon className="h-4 w-4 mr-2" data-id="element-623" />
                  Add Document
                </button>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-624">
                {booking.documents.map(doc => <div key={doc.id} className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 flex items-center justify-between" data-id="element-625">
                    <div className="flex items-center" data-id="element-626">
                      <div className="p-2 bg-blue-100 rounded-lg mr-3" data-id="element-627">
                        <FileTextIcon className="h-6 w-6 text-blue-600" data-id="element-628" />
                      </div>
                      <div data-id="element-629">
                        <h4 className="font-medium text-gray-800" data-id="element-630">
                          {doc.name}
                        </h4>
                        <p className="text-xs text-gray-500" data-id="element-631">
                          {formatSimpleDate(doc.date)}
                        </p>
                      </div>
                    </div>
                    <div className="flex space-x-2" data-id="element-632">
                      <button className="p-1.5 bg-gray-100 rounded text-gray-600 hover:bg-gray-200" data-id="element-633">
                        <PrinterIcon className="h-4 w-4" data-id="element-634" />
                      </button>
                      <button className="p-1.5 bg-gray-100 rounded text-gray-600 hover:bg-gray-200" data-id="element-635">
                        <MailIcon className="h-4 w-4" data-id="element-636" />
                      </button>
                      <button className="p-1.5 bg-blue-100 rounded text-blue-600 hover:bg-blue-200" data-id="element-637">
                        <DownloadIcon className="h-4 w-4" data-id="element-638" />
                      </button>
                      <button className="p-1.5 bg-blue-100 rounded text-blue-600 hover:bg-blue-200" data-id="element-639">
                        <ExternalLinkIcon className="h-4 w-4" data-id="element-640" />
                      </button>
                    </div>
                  </div>)}
              </div>
            </div>}
          {/* Activity Tab */}
          {activeTab === 'activity' && <div data-id="element-641">
              <div className="mb-6" data-id="element-642">
                <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-643">
                  Activity Timeline
                </h3>
                {/* Add note form */}
                <div className="mb-6" data-id="element-644">
                  <div className="flex" data-id="element-645">
                    <textarea className="flex-1 p-3 border border-gray-300 rounded-l-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" placeholder="Add a note or activity..." rows={2} value={newNote} onChange={e => setNewNote(e.target.value)} data-id="element-646"></textarea>
                    <button className="px-4 bg-blue-600 text-white rounded-r-md hover:bg-blue-700 flex items-center" onClick={handleAddNote} data-id="element-647">
                      <SendIcon className="h-4 w-4" data-id="element-648" />
                    </button>
                  </div>
                  <div className="flex justify-end mt-2" data-id="element-649">
                    <button className="text-xs text-blue-600 flex items-center mr-3" data-id="element-650">
                      <MailIcon className="h-3 w-3 mr-1" data-id="element-651" />
                      Log Email
                    </button>
                    <button className="text-xs text-blue-600 flex items-center mr-3" data-id="element-652">
                      <PhoneIcon className="h-3 w-3 mr-1" data-id="element-653" />
                      Log Call
                    </button>
                    <button className="text-xs text-blue-600 flex items-center" data-id="element-654">
                      <PlusIcon className="h-3 w-3 mr-1" data-id="element-655" />
                      More
                    </button>
                  </div>
                </div>
                {/* Timeline */}
                <div className="space-y-4" data-id="element-656">
                  {booking.activities.map(activity => <div key={activity.id} className="flex" data-id="element-657">
                      <div className="flex-shrink-0 mr-3" data-id="element-658">
                        <div className="h-10 w-10 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-659">
                          {getActivityIcon(activity.type)}
                        </div>
                      </div>
                      <div className="flex-1 bg-gray-50 rounded-lg p-4" data-id="element-660">
                        <div className="flex justify-between items-start" data-id="element-661">
                          <div data-id="element-662">
                            <p className="text-sm font-medium text-gray-800" data-id="element-663">
                              {activity.user}
                            </p>
                            <p className="text-xs text-gray-500" data-id="element-664">
                              {formatDate(activity.date)}
                            </p>
                          </div>
                          <span className="text-xs text-gray-500 capitalize" data-id="element-665">
                            {activity.type.replace('_', ' ')}
                          </span>
                        </div>
                        <p className="mt-2 text-sm text-gray-700" data-id="element-666">
                          {activity.content}
                        </p>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>}
        </div>
      </div>
    </div>;
};